import {CloudEnumEntry} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {Select} from '@mintdata/mint-kit/impl/properties/components/select/Select';
import bind from 'bind-decorator';
import {observer} from 'mobx-react';
import * as React from 'react';
import _get from 'lodash/get';

export class DropdownItem
{
    constructor(public label:string,
                public value:any)
    {
    }
}

@observer
export class DropdownWidget extends React.Component<IWidgetComponentProps, any>
{
    public static defaultProps:Partial<IWidgetComponentProps> = {
        isOutlined: true,
    };

    public static defaultItemRenderer(item:DropdownItem):JSX.Element
    {
        const {label, value} = item;

        return (
            <option key={value} value={value}>
                {label}
            </option>
        );
    }

    @bind
    private _onChange(e:React.FormEvent<any>)
    {
        const {onChange} = this.props;
        const {value} = e.target as any;

        onChange(value);
    }

    render()
    {
        const {
            prop,
            inlineLabel,
            isOutlined,
            error,
        } = this.props;

        const {value, definition} = prop;
        const {enumValues} = definition;

        const items = enumValues.entries.map((entry:CloudEnumEntry) => (
            new DropdownItem(entry.caption, entry.value)
        ));

        const selectedItem = items.find((item) => item.value === value);
        const caption = selectedItem == null ? '' : selectedItem.label;

        const errors = _get(error, 'messages', []);

        return (
            <div>
                <Select
                    inlineLabel={inlineLabel}
                    caption={caption}
                    value={value == null ? '' : value}
                    isOutlined={isOutlined}
                    onChange={this._onChange}
                >
                    {items.map(DropdownWidget.defaultItemRenderer)}
                </Select>
            </div>
        );
    }
}
